// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"388":"12fda7b9","928":"3dc69e62"}[chunkId] + ".chunk.css";
};